<template lang="pug">
div
    NuxtChild(
        keep-alive
        :keep-alive-props="{ include: ['BuildSearchPage'] }"
    )

</template>

<script>
export default {
    name: 'Builds',
    provide() {
        const liked = {}

        const saveLocalLike = (id) => {
            if (!this.likedBuilds.includes(id)) {
                this.likedBuilds.push(id)
            }

            if (process.client)
                localStorage.setItem(this.localStorageKey, JSON.stringify(this.likedBuilds))
        }

        Object.defineProperty(liked, 'builds', {
            enumerable: true,
            get: () => this.likedBuilds,
        })

        return { liked, saveLocalLike }
    },
    asyncData({ $sitewideData, error }) {
        if (!$sitewideData.config.buildsEnabled)
            return error({ statusCode: 404, message: 'Invalid URL' })
    },
    data() {
        return {
            likedBuilds: [],
            localStorageKey: 'likedBuilds',
        }
    },
    mounted() {
        this.likedBuilds = JSON.parse(localStorage.getItem(this.localStorageKey)) || []
    },
}
</script>
